// Base coverages included in the product price: EA0177 has them with no group, EA0190 in group '1'.
const INCLUDED_GROUP_BY_PRODUCT = {
  EA0177: null,
  EA0190: '1',
};

export const isIncludedTravelCoverage = (productCode, coverage) => coverage.enabled === 0
  && productCode in INCLUDED_GROUP_BY_PRODUCT
  && coverage.group_id === INCLUDED_GROUP_BY_PRODUCT[productCode];

export const getTravelCoverageText = (quote) => {
  const { product_code: productCode, coverages } = quote.quotation_data_travel_europeassistance;
  const selectedSlugs = quote.quotation_coverages.map((cov) => cov.guarantees_slug);

  return coverages
    .filter((coverage) => isIncludedTravelCoverage(productCode, coverage)
      || selectedSlugs.includes(coverage.coverage_id))
    .map((coverage) => `${coverage.title}: ${coverage.limit_desc} `)
    .join('');
};
